import StyledImage from '../../styles/StyledImage';

interface ImageProps {
  src: string;
  alt: string;
  height: string;
  width: string;
}

const Image = ({
  src,
  alt,
  height,
  width
}: ImageProps) => {
  return (
    <StyledImage alt={alt} src={src} height={height} width={width} />
  );
};

export default Image;